import { FaUserMd, FaShieldAlt, FaClipboardList, FaHospital, FaCogs, FaHeartbeat, } from "react-icons/fa";

import { motion } from "framer-motion";


export default function HealthcareTransformation() {
    return (
        <>
            <div className="min-h-screen flex flex-col items-center mt-3  text-white py-16 px-6">

                {/* Introduction Section */}
                <div className="text-center w-full mb-12">
                    <h1 className="text-[25px]  font-bold mb-4  flex justify-center items-center  text-black 
                    bg-gradient-to-r from-[#2a627a] to-transparent bg-opacity-100 
                    backdrop-blur-lg p-4 rounded-lg shadow-lg transition-all duration-300 drop-shadow-lg">
                        Redefining Healthcare with Smart Solutions
                    </h1>
                    <p className="text-[15px]  text-gray-800 mb-6">
                        At <span className="font-bold text-[#2a627a]">HIKEHEALTH GS</span>, we bring cutting-edge technology to healthcare.
                        From <span className="text-[#2a627a] font-bold">Automation to compliance</span> , we simplify complex processes so you can focus on Patient care.
                    </p>
                    {/* <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg shadow-md transition-transform transform hover:scale-105">
                        Explore Our Solutions
                    </button> */}
                </div>

                {/* Features Section */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8  w-full max-w-6xl mb-5">
                    <FeatureCard
                        icon={<FaUserMd className="text-[#2a627a] text-5xl" />}
                        title="Elevated Patient Experience"
                        description="Enhance patient engagement with AI-driven automation, offering seamless and personalized care."
                    />
                    <FeatureCard
                        icon={<FaShieldAlt className="text-[#2a627a] text-5xl" />}
                        title="Effortless Compliance"
                        description="Stay ahead with automated HIPAA compliance and security measures that protect your data and ensure regulatory adherence."
                    />
                    <FeatureCard
                        icon={<FaClipboardList className="text-[#2a627a] text-5xl" />}
                        title="AI-Powered Documentation"
                        description="Simplify charting and clinical workflows with intelligent automation that streamlines healthcare processes.."
                    />
                    <FeatureCard
                        icon={<FaHospital className="text-[#2a627a] text-5xl" />}
                        title="Optimized Workforce"
                        description="Boost operational efficiency by streamlining staff operations, improving coordination, and reducing manual tasks."
                    />
                    <FeatureCard
                        icon={<FaCogs className="text-[#2a627a] text-5xl" />}
                        title="Seamless Integration"
                        description="Achieve optimal interoperability across clinical, provider, payer, and patient systems, ensuring smooth communication and coordination."
                    />
                    <FeatureCard
                        icon={<FaHeartbeat className="text-[#2a627a] text-5xl " />}
                        title="Faster Patient Recovery"
                        description="Improve patient health outcomes with real-time data and smart analytics to support timely decision-making and recovery."
                    />
                </div>
            </div>

        </>
    );
}

const FeatureCard = ({ icon, title, description, }) => (
    <motion.div
        whileHover={{ scale: 1.05, rotate: 2 }}
        transition={{ duration: 0.3 }}
        // className=" group relative flex flex-col items-center bg-[#03ab3b] bg-opacity-70 hover:bg-[#03ab3b] p-6 rounded-xl border border-gray-800 shadow-lg transition duration-300 hover:shadow-2xl hover:border-gray-700 group"
        className=" group relative flex flex-col items-center bg-gray-300 bg-opacity-70 hover:bg-gray-300 p-6 rounded-xl border border-[#2a627a] shadow-lg transition duration-300 hover:shadow-2xl hover:border-[#2a627a] group"
    >
        <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className=" mb-3 group-hover:scale-110 transition-transform duration-300"
        >

            {icon}
            <h3 className="text-lg font-bold  text-[#2a627a] mb-2 text-center">{title}</h3>
            <p className="text-black text-sm text-center">{description}</p>

        </motion.div>
    </motion.div>
);